export default {
  name: 'manage',
  path: 'manage',
  component: () => import('@/views/container/Redirect.vue'),
  meta: {
    title: '管理中心',
    redirect: true,
    hideSubMenu: true,
    hideMenu: true
  },
  children: [
    {
      name: 'system',
      path: 'system',
      component: () => import('@/views/container/Redirect.vue'),
      meta: {
        title: '系统设置',
        redirect: true
      },
      children: [
        {
          name: 'role',
          path: 'role',
          component: () => import('@/views/manage/system/role/Role.vue'),
          meta: { title: '角色管理' }
        }, {
          name: 'cycle',
          path: 'cycle',
          component: () => import('@/views/manage/system/cycle/Cycle.vue'),
          meta: { title: '常用周期管理' }
        }
      ]
    },
    {
      name: 'face',
      path: 'face',
      component: () => import('@/views/manage/face/Face.vue'),
      meta: { title: '人脸审核' }
    },
    {
      name: 'flow-center',
      path: 'flow-center',
      component: () => import('@/views/container/Redirect.vue'),
      meta: { title: '流程管理', redirect: true },
      children: [
        {
          name: 'flow-components',
          path: 'flow-components',
          component: () => import('@/views/manage/flow-iframe/FlowIframe.vue'),
          meta: { title: '组件管理' }
        },
        {
          name: 'flow-model',
          path: 'flow-model',
          component: () => import('@/views/manage/flow-iframe/FlowIframe.vue'),
          meta: { title: '模型管理' }
        },
        {
          name: 'flow-instance',
          path: 'flow-instance',
          component: () => import('@/views/manage/flow-iframe/FlowIframe.vue'),
          meta: { title: '数据管理' }
        },
        {
          name: 'flow-statistics',
          path: 'flow-statistics',
          component: () => import('@/views/manage/flow-iframe/FlowIframe.vue'),
          meta: { title: '数据统计' }
        },
        {
          name: 'flow-form',
          path: 'flow-form',
          component: () => import('@/views/manage/flow-iframe/FlowFormManager.vue'),
          meta: { title: '表单管理' }
        }
      ]
    }
  ]
};
